// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__bVstN","hero__title":"styles_hero__title__F604_","hero__text":"styles_hero__text__0ql0t"};